import React from 'react'
import { FaCrown } from 'react-icons/fa6'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'

export const UpdatePlan = () => {
  return (
    <div className="text-center my-10 p-4 bg-white shadow-lg rounded-xl max-w-2xl mx-auto">
    {/* Icon */}
    <div className="flex justify-center mb-4">
      <FaCrown className="text-4xl text-yellow-500" />
    </div>

    {/* Heading */}
    <h2 className="text-2xl font-bold text-gray-800 mb-1">
      <FormattedMessage id="upgrade_your_plan" defaultMessage="Upgrade your plan!" />
    </h2>

    {/* Description */}
    <p className="text-gray-600 mb-4">
      <FormattedMessage
        id="upgrade_for_full_access"
        defaultMessage="Upgrade your plan to access all influencers and advanced features"
      />
    </p>

    {/* Upgrade Button */}
    <Link
      to="/pricing"
      className="btn btn-primary text-white px-8 py-3 rounded-lg hover:opacity-90 transition-opacity flex items-center justify-center mx-auto"
    
    >
      <FaCrown className="mr-2" />
      <FormattedMessage
        id="upgrade_plan"
        defaultMessage="Upgrade Plan"
      />
    </Link>
  </div>
  )
}
